//@ts-ignore
import urlon from 'urlon';

export default (obj: any) => urlon.stringify(obj);
